// Queries
import designerSearch from "./DesignerSearchQuery.gql";

export const Query = {
    designerSearch,
};
